import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDotGrid1x3HorizontalTight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"dot-grid-1x3-horizontal-tight, menu, drag, grab"} maskId="square-filled-radius-0-stroke-1-IconDotGrid1x3HorizontalTight"><rect x="3" y="10" width="4" height="4" fill="currentColor"/><rect x="10" y="10" width="4" height="4" fill="currentColor"/><rect x="17" y="10" width="4" height="4" fill="currentColor"/></CentralIconBase>;
}));

export default IconDotGrid1x3HorizontalTight;
